import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import Box from '@mui/material/Box';
import ClassAssemblySidebar2025 from '../ClassAssemblySidebar2025';


const ClassAssembly2F2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2025}/home/events-activities/class-assembly/2F/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/class-assembly/2F/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/class-assembly/2F/3.webp`;
  const p4 = `${config.base_image_url_2025}/home/events-activities/class-assembly/2F/4.webp`;
  const p5 = `${config.base_image_url_2025}/home/events-activities/class-assembly/2F/5.webp`;
  

  const photos = [
    
    {
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
 {
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
}

  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      Makara Sankranti
        </Typography>
        <Typography
        fontSize = "x-small">
        <br/><br/>
      Class: 2F     Date: 12, 13 & 14 January

        </Typography>
        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “Festivals bring us together and remind us to celebrate love, culture, and happiness.”

<br/>
        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        The students of Class 2F conducted a vibrant and meaningful assembly on the theme Makar Sankranti across three days 12, 13, and 14 January. 
        <br></br>
        On Day 1, the programme began with a thought and short talk introducing the importance of festivals in our lives and how they bring joy, culture and togetherness. The students of Class 2A then presented the Word of the Month QUENCH. Their clear explanation and well-chosen examples made the presentation both engaging and impressive.  
        <br></br>
        On Day 2, the assembly began with a meaningful thought based on the spirit of Makar Sankranti, followed by an insightful talk focusing specifically on the significance, traditions, and cultural richness of the festival. The message beautifully captured the essence of new beginnings and gratitude.
        <br></br>
        The final day also opened with a thoughtful message centred on Makar Sankranti, uplifting the festive atmosphere. The students extended warm wishes in their mother tongue, greeting everyone in different Indian languages. They also shared interesting information about how various states celebrate Makara Sankranti from kite flying in Gujarat, to Pongal in Tamil Nadu and Sankranti in Karnataka. The assembly then featured a lively dance performance, which added colour and joy to the programme. A small token of love Ellu bella was presented to the Principal Ms Sheeja Manoj Ma’am as a gesture of gratitude. The assembly concluded on a cheerful and festive note, leaving everyone enriched with knowledge and filled with the spirit of celebration.
        <br></br>
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   "Makar Sankranti reminds us that every new beginning is filled with hope, light, and positivity."

<br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <ClassAssemblySidebar2025 />
             </Box>
             <Box marginBottom={4}>
               <Archive2022 />
             </Box>
           {/* <SidebarNewsletter /> */}
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default ClassAssembly2F2025